import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import styles from './links-poppers-styles.module.css';

export const LinksPopper = ({
  selectedRowForLinks,
  popperForLinksPosition,
  setSelectedRowForLinks,
}) => {
  const popperRef = useRef(null);

  useEffect(() => {
    if (!selectedRowForLinks) return;

    const handleClickOutside = (event) => {
      if (popperRef.current && !popperRef.current.contains(event.target)) {
        setSelectedRowForLinks(null);
      }
    };

    // Use a small delay to avoid immediate closure when opening
    const timeoutId = setTimeout(() => {
      document.addEventListener('mousedown', handleClickOutside);
    }, 0);

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [selectedRowForLinks, setSelectedRowForLinks]);

  // Handle scroll to close popper
  useEffect(() => {
    if (!selectedRowForLinks) return;

    const handleScroll = () => {
      setSelectedRowForLinks(null);
    };

    window.addEventListener('scroll', handleScroll, true);
    document.addEventListener('scroll', handleScroll, true);

    return () => {
      window.removeEventListener('scroll', handleScroll, true);
      document.removeEventListener('scroll', handleScroll, true);
    };
  }, [selectedRowForLinks, setSelectedRowForLinks]);

  const links =
    selectedRowForLinks?.links || selectedRowForLinks?.terminal?.links;

  // Calculate position for fixed positioning (viewport coordinates)
  const leftPosition =
    popperForLinksPosition.right - popperForLinksPosition.width / 2;
  const topPosition = popperForLinksPosition.top;

  const handleClosePopper = () => {
    setSelectedRowForLinks(null);
  };

  const popperContent = selectedRowForLinks && (
    <div
      ref={popperRef}
      className={`bg-white shadow-small-popper fixed p-4 border border-solid border-border-tertiary rounded ${styles.popperSlideIn}`}
      style={{
        top: `${topPosition}px`,
        left: `${leftPosition}px`,
        marginTop: '-8px',
        zIndex: 9999,
      }}
      onClick={(e) => e.stopPropagation()}>
      <div
        className="absolute left-1/2 top-full w-0 h-0 "
        style={{
          borderLeft: '9px solid transparent',
          borderRight: '9px solid transparent',
          borderTop: '9px solid #E1E4EA',
          transform: 'translate(-50%, 0)',
        }}
      />

      <div
        className="absolute left-1/2 top-full z-10 w-0 h-0 "
        style={{
          borderLeft: '8px solid transparent',
          borderRight: '8px solid transparent',
          borderTop: '8px solid white',
          marginTop: '-1px',
          transform: 'translate(-50%, 0)',
        }}
      />
      <ul
        onClick={handleClosePopper}
        className="min-w-max items-start flex flex-col gap-2 text-xs test-primary-text m-0 p-0 ml-4">
        <li>
          <a
            className="underline cursor-pointer text-primary-text hover:text-primary-blue transition-colors duration-300"
            target="_blank"
            rel="noreferrer"
            href={links?.gate_schedule}>
            Gate Schedule
          </a>
        </li>
        <li>
          <a
            className="underline cursor-pointer text-primary-text hover:text-primary-blue transition-colors duration-300"
            target="_blank"
            rel="noreferrer"
            href={links?.restriction}>
            Receivable
          </a>
        </li>
        <li>
          <a
            className="underline cursor-pointer text-primary-text hover:text-primary-blue transition-colors duration-300"
            target="_blank"
            rel="noreferrer"
            href={
              selectedRowForLinks?.new_appointment
                ? links.new_appointment
                : links?.appointments
            }>
            Terminal Link
          </a>
        </li>
      </ul>
    </div>
  );

  return popperContent ? createPortal(popperContent, document.body) : null;
};
